import { Modal, Button } from 'antd';
/* eslint-disable */

// import './BcConvertModal.css';
import { setDisablerFalse, setDisablerTrue } from 'redux/SidebarDisablerSlice';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { RollbackOutlined, UserAddOutlined } from '@ant-design/icons';
import {
    bcConvertWithoutEsignApi,
    // checkMerchantOrBCAPI,
    conversionSlabApi,
    // convertAsBc,
    getBCAgreementHtml,
    signBcAgreementApi
} from 'utils/API/Merchant APIs/MerchantApiCalls';
import { useState } from 'react';
// import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import { Tabs, Table } from 'antd';
import { Dialog, Tooltip, Typography } from '@mui/material';
import Chip from '@mui/material/Chip';
import LinearProgress from '@mui/material/LinearProgress';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { globalNotifySuccess } from 'views/utilities/AlertToast';
import BcFee from './EsignAgreement/BcFee';
import { mpinExtensionApi } from 'utils/API/Merchant APIs/MpinApiCalls';

const styles = {
    // Styles from .custom-modal .ant-modal-content
    // Note: These would typically be applied to the modal content wrapper. 
    // Since we are moving to inline styles, we might need to apply these to the inner containers 
    // or rely on default modal styles if specific internal class targeting is not possible inline.
    // However, we can apply specific styles to our container divs.
    
    // Styles from .custom-modal .modal-content
    innerContent: {
        padding: '20px',
        textAlign: 'center',
    },
    // Styles from .custom-modal h2
    heading: {
        marginBottom: '10px',
        color: '#1890ff',
    },
    // Styles from .custom-modal p
    paragraph: {
        color: '#333',
    },
    // Styles from .rejected-modal
    rejectedModal: {
        textAlign: 'center',
        padding: '30px 20px',
    },
    // Styles from .rejected-icon
    rejectedIcon: {
        width: '70px',
        height: '70px',
        margin: '0 auto 16px',
        borderRadius: '50%',
        background: '#fff1f0',
        color: '#ff4d4f',
        fontSize: '36px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '2px solid #ff4d4f',
    },
    // Styles from .rejected-title
    rejectedTitle: {
        color: '#ff4d4f',
        fontWeight: '600',
        marginBottom: '10px',
    },
    // Styles from .rejected-text
    rejectedText: {
        color: '#595959',
        fontSize: '14px',
        marginBottom: '24px',
    },
    // Styles from .rejected-btn
    rejectedBtn: {
        minWidth: '220px',
    }
};

const BcConvertModal = (props) => {
    const isWhitelabel = localStorage.getItem('whitelabelStatus');
    const premiumPlanStatus = localStorage.getItem('premium_Plan_Status');
    // eslint-disable-next-line
    const serviceName = props?.serviceName;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const agentid = localStorage.getItem('id');
    const payload = { agentid };
    // const open = true;
    const currentRoute = window.location.pathname;
    // eslint-disable-next-line
    const handleClose = props.handleclose;
    const bcStatusProps = props?.showStatus;
    const bcStatusFromLocal = localStorage.getItem('merchantToBcStatus');
    const bcStatus = bcStatusProps || bcStatusFromLocal;
    // eslint-disable-next-line
    const shouldshowEsign = props?.shouldshowEsign;
    const [open, setOpen] = useState(true);
    // const conditionsDocumentLink = 'https://aceware-commons-public.s3.ap-south-1.amazonaws.com/public_files/image_663e0fd88c369.pdf';
    const addendum1Link = 'https://aceware-commons-public.s3.ap-south-1.amazonaws.com/public_files/Addendum-1.pdf';
    const addendum2Link = 'https://aceware-commons-public.s3.ap-south-1.amazonaws.com/public_files/Addendum-2.pdf';

    // console.log('modal open', open);
    // const [loadingConvertion, setLoadingConvertion] = useState(false);
    const [slabLoading, setSlabLoading] = useState(false);
    const [isPending, setIsPending] = useState('');
    const [allSlab, setAllSlab] = useState([]);
    const [bcPaymentSlab, setBcPaymentSlab] = useState();
    const [selectedServiceSlab, setSelectedServiceSlab] = useState([]);
    const [bcAgreementHtmlFile, setBcAgreementHtmlFile] = useState('');
    const [signBcAgreementHtml, setSignAgreementHtml] = useState('');
    const [agreementFileModalOpen, setAgreementFileModalOpen] = useState(false);
    const [agreementLoading, setAgreementLoading] = useState(false);
    const [checkedStatus, setCheckedStatus] = useState(false);
    const [checkedStatus2, setCheckedStatus2] = useState(false);
    const [checkError, setCheckError] = useState(false);
    const [esignShow, setEsignShow] = useState(false);
    const [BcAgreementShow, setBcAgrementShow] = useState(false);
    const { TabPane } = Tabs;
    // const bcConversionAgreementLink = 'https://aceware-commons-public.s3.ap-south-1.amazonaws.com/MERCHANT+AGREEMENT-+review-2.docx';

    const columns = [
        {
            title: 'Amount',
            dataIndex: 'amount',
            key: 'amount'
        },
        {
            title: 'BC',
            dataIndex: 'BC',
            key: 'BC'
        },
        {
            title: 'Premium BC',
            dataIndex: 'PremiumBC',
            key: 'PremiumBC'
        }
    ];

    const divStyle = {
        maxWidth: '1300px', // Set the maximum width you desire
        maxHeight: '300px', // Set the maximum height you desire
        overflow: 'auto' // Add scrollbars if content overflows the fixed size
        // border: '1px solid #ccc' // Add a border for visual clarity
    };
    const handleAgreementModalClose = () => {
        setCheckError(false);
        setSignAgreementHtml('');
        setAgreementFileModalOpen(false);
        setEsignShow(false);
        setOpen(false);
        handleClose();
        navigate('/merchant-home');
    };
    const handleCheck1 = (e) => {
        if (e.target.checked) {
            if (checkedStatus2) {
                setCheckError(false);
            }
        } else {
            setCheckError(true);
        }
        setCheckedStatus(e.target.checked);
    };
    const handleCheck2 = (e) => {
        if (e.target.checked) {
            if (checkedStatus) {
                setCheckError(false);
            }
        } else {
            setCheckError(true);
        }
        setCheckedStatus2(e.target.checked);
    };
    const handleAgreeProceed = () => {
        if (checkedStatus && checkedStatus2) {
            setCheckError(false);
            eSignAgreement();
        } else {
            setCheckError(true);
        }
    };
    const eSignAgreement = async () => {
        setAgreementLoading(true);
        const eSignAgreementResponse = await signBcAgreementApi(payload);
        if (eSignAgreementResponse?.data?.success) {
            const htmlFileSign = eSignAgreementResponse?.data?.data;
            setSignAgreementHtml(htmlFileSign);
            const innerTab = window.open('about:blank', 'Inner Tab', 'width=800,height=1000');
            if (innerTab) {
                // Write HTML content to the new tab
                innerTab.document.open();
                innerTab.document.write(htmlFileSign);
                innerTab.document.close();
                handleBackClick();
            } else {
                // Handle if the browser blocks popup
                alert('Please allow popups for this site to open the inner tab.');
            }

            handleAgreementModalClose();
        }
        setAgreementLoading(false);
    };
    const handleShowAgreement = async () => {
        try {
            if (isWhitelabel === 'true') {
                setAgreementLoading(true);
                const response = await bcConvertWithoutEsignApi(payload);
                if (response.status === 200) {
                    handleClose();
                    globalNotifySuccess('Successfully converted as a BC');
                    window.location.reload();
                }
                setAgreementLoading(false);
                return;
            }
            setAgreementFileModalOpen(true);
            setAgreementLoading(true);
            const agreementHtmlResponse = await getBCAgreementHtml(payload);
            const htmlFile = agreementHtmlResponse?.data?.data;
            setBcAgreementHtmlFile(htmlFile);
            setAgreementLoading(false);
        } catch (error) {
            setAgreementLoading(false);
        }
    };
    const handleBackClick = () => {
        dispatch(setDisablerFalse());
        if (currentRoute === '/merchant-home') {
            handleClose();
            // setOpen(false);
        } else {
            navigate('/merchant-home');
        }
    };
    // eslint-disable-next-line
    const isOpen = props?.isOpen;
    const getConversionSlabs = async () => {
        setSlabLoading(true);
        const payload = { agent_id: localStorage.getItem('id') };
        const slabResponse = await conversionSlabApi(payload);
        setSlabLoading(false);
        const allSlabsData = slabResponse?.data?.data;
        setAllSlab(allSlabsData);
        setBcPaymentSlab(slabResponse?.data?.data[0]?.slab);
        if (slabResponse?.data?.data[0]?.slab[0]?.bc_one_time_fee_paid === true && bcStatus !== 'rejected') {
            setEsignShow(true);
        }
        allSlabsData.map((item) => {
            if (item?.service === serviceName) {
                setSelectedServiceSlab(item?.slab);
            }
        });
    };
    useEffect(() => {
        // setOpen(true);
        // eslint-disable-next-line

        setOpen(isOpen);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);
    useEffect(() => {
        if (open) {
            dispatch(setDisablerTrue());
        } else {
            dispatch(setDisablerFalse());
        }
        // eslint-disable-next-line
        const pendingStatus = props?.isPending;

        setIsPending(pendingStatus);
        // eslint-disable-next-line
    }, [open]);

    const handleEsign = () => {
        // handleClose();

        if (bcStatus === 'rejected') {
            setEsignShow(false);
        } else {
            setEsignShow(true);
        }
    };

    useEffect(() => {
        const eSignAgreement = async () => {
            try {
                setAgreementLoading(true);

                const agreementHtmlResponse = await getBCAgreementHtml(payload);
                const htmlFile = agreementHtmlResponse?.data?.data;
                setBcAgreementHtmlFile(htmlFile);
                setAgreementLoading(false);
            } catch (error) {
                console.error('eSign Agreement error:', error);
            } finally {
                setAgreementLoading(false);
            }
        };

        eSignAgreement();
        MpinExtender();
        getConversionSlabs();
    }, []);

    const MpinExtender = async () => {
        try {
            const mpinStatus = localStorage.getItem('login-type');
            if (mpinStatus === 'MPIN') {
                const payload = { agentid: localStorage.getItem('id') };
                const response = await mpinExtensionApi(payload);
                if (response?.data?.success) {
                    localStorage.setItem('token', response?.data?.jwt);
                }
            }
        } catch (e) {
            console.log(e.message);
            handleCatchError(e);
        }
    };

    const handleBcFeeClose = () => {
        setAgreementFileModalOpen(false);
    };

    return (
        <Modal closable={false} open={open} footer={false} zIndex={2000}>
            {bcStatus === 'rejected' ? (
                <div style={styles.rejectedModal}>
                    <div style={styles.rejectedIcon}>✖</div>

                    <h2 style={styles.rejectedTitle}>Conversion Rejected</h2>

                    <p style={styles.rejectedText}>
                        Your request to become a BC has been rejected. Please review the details or contact support for further assistance.
                    </p>

                    <Button type="primary" danger icon={<RollbackOutlined />} onClick={handleBackClick} style={styles.rejectedBtn}>
                        Back to other services
                    </Button>
                </div>
            ) : isPending ? (
                <div style={styles.innerContent}>
                    <h2 style={styles.heading}>Conversion is pending</h2>
                    <p style={styles.paragraph}>Your request to become a BC is currently pending. Please wait until the request is approved.</p>

                    <Button type="primary" onClick={handleBackClick} icon={<RollbackOutlined />} style={{ marginLeft: 6 }}>
                        Back to other services
                    </Button>
                </div>
            ) : (
                <>
                    <Typography variant="subtitle1" color="Highlight" fontWeight="bold">
                        {shouldshowEsign === 'true'
                            ? `Dear Agent, we noticed that you have not yet completed the Aadhaar E-sign process.`
                            : isWhitelabel === 'true'
                            ? `Dear Merchant, we noticed that you have not yet completed the Aadhaar E-sign process.`
                            : `Dear Merchant, you are advised to upgrade to a BC Agent to earn additional commission.`}
                    </Typography>

                    {!serviceName && shouldshowEsign !== 'true' && isWhitelabel !== 'true' ? (
                        <Tabs style={{ marginBottom: 10 }}>
                            {allSlab?.map((item, index) => (
                                <TabPane tab={item?.label} key={index}>
                                    <Table loading={slabLoading} dataSource={item.slab} pagination={false}>
                                        <Table.Column title="Amount" dataIndex="amount" align="center" />
                                        <Table.Column title="BC" dataIndex="bc_one_time_fee" align="center" />
                                        {premiumPlanStatus === 'true' && (
                                            <Table.Column title="Premium BC" dataIndex="PremiumBC" align="center" />
                                        )}
                                    </Table>
                                </TabPane>
                            ))}
                        </Tabs>
                    ) : null}

                    <Tooltip title={bcPaymentSlab?.[0]?.bc_one_time_fee_message}>
                        <Button loading={agreementLoading} icon={<UserAddOutlined />} onClick={handleShowAgreement} type="primary" danger>
                            {shouldshowEsign === 'true' ? 'Complete E-sign Now' : 'Convert as a BC'}
                        </Button>
                    </Tooltip>

                    <Button icon={<RollbackOutlined />} type="primary" onClick={handleBackClick} style={{ marginLeft: 6 }}>
                        Go back to home
                    </Button>
                </>
            )}
            {!isPending && (
                <Modal
                    zIndex={2200}
                    title={<Chip color="info" label={'BC Agreement '} sx={{}} />}
                    className="custom-modal2"
                    wrapClassName="custom-modal-backdrop"
                    centered
                    open={esignShow}
                    onCancel={handleAgreementModalClose}
                    width={900}
                    style={{ height: 500 }}
                    footer={
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <FormControlLabel
                                    control={<Checkbox onChange={handleCheck1} />}
                                    label={
                                        <Typography>
                                            I have read and agree to the
                                            <a href={addendum1Link} target="_blank">
                                                <span> Addendum 1</span>
                                            </a>
                                        </Typography>
                                    }
                                />
                                <p style={{ marginLeft: 10 }}></p>
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <FormControlLabel
                                    control={<Checkbox onChange={handleCheck2} />}
                                    label={
                                        <Typography>
                                            I have read and agree to the
                                            <a href={addendum2Link} target="_blank">
                                                <span> Addendum 2</span>
                                            </a>
                                        </Typography>
                                    }
                                />
                            </div>
                            {checkError && <span style={{ color: 'red', paddingLeft: 10 }}>Please check all boxes to proceed</span>}
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                <Button
                                    loading={agreementLoading}
                                    onClick={handleAgreeProceed}
                                    style={{ marginTop: 2, marginBottom: 4, width: '120px' }}
                                    type="primary"
                                    disabled={checkError}
                                >
                                    {agreementLoading ? '' : 'Agree and Sign'}
                                </Button>
                            </div>
                        </div>
                    }
                    // closable={false}
                    maskClosable={false}
                >
                    <>
                        {agreementLoading ? (
                            <LinearProgress />
                        ) : (
                            <div style={{ textAlign: 'center', border: '1px solid #ccc' }}>
                                <div
                                    style={divStyle}
                                    dangerouslySetInnerHTML={{ __html: signBcAgreementHtml ? signBcAgreementHtml : bcAgreementHtmlFile }}
                                ></div>
                            </div>
                        )}
                    </>
                </Modal>
            )}
            <Dialog onClose={handleBcFeeClose} open={agreementFileModalOpen} sx={{ zIndex: 2201 }}>
                {agreementFileModalOpen && (
                    <BcFee
                        message={bcPaymentSlab?.[0]?.bc_one_time_fee_message}
                        feeDetails={bcPaymentSlab?.[0]?.bc_one_time_fee}
                        qrValue={bcPaymentSlab?.[0]?.qr_value}
                        plan_id={bcPaymentSlab?.[0]?.bc_one_time_plan_id}
                        onOk={handleEsign}
                        onClose={handleBcFeeClose}
                    />
                )}
            </Dialog>
        </Modal>
    );
};

export default BcConvertModal;
